<template>
    <div class="flex flex-wrap">
        <div class="lg:w-1/2 w-full max-lg:mb-[65px]">
            <form class="lg:pl-[35%] pl-[15%] pt-[2%]">
                <label
                    class="block relative pl-[35px] mb-[12px] cursor-pointer text-2xl select-none"
                    v-for="organisation in formFields.organisation"
                    >{{ organisation }}
                    <input
                        type="radio"
                        name="organisation"
                        class="absolute opacity-0 cursor-pointer h-0 w-0 peer"
                    />
                    <span
                        class="absolute top-0 left-0 h-[25px] w-[25px] bg-[#ccc] rounded-[50px] peer-checked:bg-[#0faedd]"
                    ></span>
                </label>
            </form>
        </div>
        <div class="lg:w-1/2 w-full">
            <div class="relative inline-block w-full text-gray-700 mb-3">
                <select
                    class="lg:w-3/4 w-full h-[3.5rem] pl-3 pr-6 text-base placeholder-gray-600 border rounded-lg appearance-none focus:shadow-outline"
                >
                    <option value="NULL">Erfasst von</option>
                    <option v-for="person in formFields.people" :value="person.initials">
                        {{ person.name }}
                    </option>
                </select>
                <div
                    class="absolute inset-y-0 lg:right-[25%] right-0 flex items-center px-2 pointer-events-none"
                >
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
                        <path
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4
                            4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                            fill-rule="evenodd"
                        ></path>
                    </svg>
                </div>
            </div>
            <div class="relative inline-block w-full text-gray-700 mb-3">
                <select
                    class="lg:w-3/4 w-full h-[3.5rem] pl-3 pr-6 text-base placeholder-gray-600 border rounded-lg appearance-none focus:shadow-outline"
                >
                    <option value="NULL">Beauftragt durch</option>
                    <option v-for="person in formFields.people" :value="person.initials">
                        {{ person.name }}
                    </option>
                </select>
                <div
                    class="absolute inset-y-0 lg:right-[25%] right-0 flex items-center px-2 pointer-events-none"
                >
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
                        <path
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4
                            4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                            fill-rule="evenodd"
                        ></path>
                    </svg>
                </div>
            </div>
            <div class="relative inline-block w-full text-gray-700 mb-3">
                <select
                    class="lg:w-3/4 w-full h-[3.5rem] pl-3 pr-6 text-base placeholder-gray-600 border rounded-lg appearance-none focus:shadow-outline"
                >
                    <option value="NULL">Bearbeitet durch</option>
                    <option v-for="person in formFields.people" :value="person.initials">
                        {{ person.name }}
                    </option>
                </select>
                <div
                    class="absolute inset-y-0 lg:right-[25%] right-0 flex items-center px-2 pointer-events-none"
                >
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
                        <path
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4
                            4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                            fill-rule="evenodd"
                        ></path>
                    </svg>
                </div>
            </div>
        </div>
        <div class="relative inline-block w-full text-gray-700 my-5">
            <div class="flex justify-between flex-wrap mt-2">
                <div class="relative w-full">
                    <input
                        id="Betreff"
                        class="w-full rounded-lg shadow pl-4 pt-3 peer placeholder-transparent h-[60px] border-[1px] border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-b-[#db0720]"
                        placeholder="Betreff"
                    />
                    <label
                        for="Betreff"
                        class="absolute left-4 text-gray-500 text-sm top-1 peer-placeholder-shown:text-lg peer-placeholder-shown:text-gray-600 peer-placeholder-shown:top-4 transition-all peer-focus:top-1 peer-focus:text-gray-500 peer-focus:text-sm hover:cursor-text"
                        >Betreff
                        <!-- translate -->
                    </label>
                </div>
            </div>
            <div class="my-4 w-full">
                <textarea
                    name="wow"
                    class="w-full rounded shadow pl-4 pt-3 peer h-[400px] border-[1px] border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-b-[#db0720]"
                    placeholder="E-Mail Nachricht"
                ></textarea>
            </div>
        </div>

        <div class="lg:w-1/3 w-full max-lg:mb-[50px] max-lg:mt-[30px]">
            <form class="lg:pl-[35%] pl-[15%] pt-[4%]">
                <label
                    class="block relative pl-[35px] mb-[12px] cursor-pointer text-2xl select-none"
                    v-for="instance in formFields.periodicity"
                >
                    {{ instance }}
                    <input
                        type="radio"
                        name="periodicity"
                        class="absolute opacity-0 cursor-pointer h-0 w-0 peer"
                    />
                    <span
                        class="absolute top-0 left-0 h-[25px] w-[25px] bg-[#ccc] rounded-[50px] peer-checked:bg-[#0faedd]"
                    ></span>
                </label>
            </form>
        </div>
        <div class="lg:w-1/3 w-full max-lg:mb-[50px]">
            <form class="lg:pl-[35%] pl-[15%] pt-[4%]">
                <label
                    class="block relative pl-[35px] mb-[12px] cursor-pointer text-2xl select-none"
                    v-for="priority in formFields.priority"
                    >{{ priority }}
                    <input
                        type="radio"
                        name="prority"
                        class="absolute opacity-0 cursor-pointer h-0 w-0 peer"
                    />
                    <span
                        class="absolute top-0 left-0 h-[25px] w-[25px] bg-[#ccc] rounded-[50px] peer-checked:bg-[#0faedd]"
                    ></span>
                </label>
            </form>
        </div>

        <div class="lg:w-1/3 w-full max-lg:mb-[50px]">
            <div class="relative w-full" v-for="field in formFields.details">
                <input
                    id="von"
                    class="w-full mb-2 rounded-lg shadow pl-4 pt-3 peer placeholder-transparent h-[60px] border-[1px] border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-b-[#db0720]"
                    :placeholder="field.description"
                    :type="field.type"
                    :value="field.value"
                    :disabled="field.disabled"
                />
                <label
                    for="von"
                    class="absolute left-4 text-gray-500 text-sm top-1 peer-placeholder-shown:text-lg peer-placeholder-shown:text-gray-600 peer-placeholder-shown:top-4 transition-all peer-focus:top-1 peer-focus:text-gray-500 peer-focus:text-sm hover:cursor-text"
                    :for="field.description"
                    >{{ field.description }}</label
                >
            </div>
            <div class="relative inline-block w-full text-gray-700 mb-3">
                <select
                    class="w-full h-[3.5rem] pl-3 pr-6 text-base placeholder-gray-600 border rounded-lg appearance-none focus:shadow-outline shadow-md"
                >
                    <option value="NULL">Erledigt von</option>
                    <option v-for="person in formFields.people" :value="person.initials">
                        {{ person.name }}
                    </option>
                </select>
                <div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
                        <path
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4
                            4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                            fill-rule="evenodd"
                        ></path>
                    </svg>
                </div>
            </div>
        </div>

        <div class="w-1/2 mt-4 pt-5 align-left">
            <button
                class="py-2 text-center font-medium align-middle leading-10 cursor-pointer rounded shadow bg-[#db0720] text-white hover:bg-[#ce0720] w-[99%] m-2 ml-0"
                onclick="if (!confirm('E-Mail senden?')) return false;"
            >
                <strong> E-Mail senden </strong>
            </button>
        </div>
        <div class="w-1/2 mt-4 pt-5">
            <button
                class="py-2 text-center font-medium align-middle leading-10 cursor-pointer rounded shadow bg-[#db0720] text-white hover:bg-[#ce0720] w-[99%] m-2"
            >
                <strong> PDF erstellen > </strong>
            </button>
        </div>
        <div class="w-full">
            <router-link to="/timesheet">
                <button
                    class="h-[50px] text-lg text-center font-medium align-middle leading-8 cursor-pointer rounded shadow bg-[#FFF] text-black border-[1px] border-black hover:bg-[#F7F7F7] w-full"
                    onclick="if (!confirm('Änderungen verwerfen?')) return false;"
                >
                    <strong> Abbrechen </strong>
                </button>
            </router-link>
        </div>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue'

    export default defineComponent({
        data() {
            return {
                formFields: {
                    organisation: ['nanoo.tv', 'Play to learn', 'Finanzdienste', 'Werft22'],
                    periodicity: [
                        'Einmalig',
                        'Jede Woche',
                        'Alle zwei Wochen',
                        'Alle drei Wochen',
                        'Jeden Monat',
                        'Alle zwei Monate',
                        'Quartalsweise',
                        'Unbestimmt',
                    ],
                    priority: ['Prio 1 (+)', 'Prio 2', 'Prio 3', 'Prio 4', 'Prio 5 (-)'],
                    people: [
                        {
                            name: 'Andreas Trottmann',
                            initials: 'AT',
                        },
                        {
                            name: 'Andy Schär',
                            initials: 'AS',
                        },
                        {
                            name: 'Anita Nixon',
                            initials: 'AN',
                        },
                        {
                            name: 'Beatrice Tobler',
                            initials: 'BT',
                        },
                        {
                            name: 'Henning Timcke',
                            initials: 'HT',
                        },
                        {
                            name: 'Stefan Rickli',
                            initials: 'SR',
                        },
                        {
                            name: 'Teresa Zulli',
                            initials: 'TZ',
                        },
                    ],
                    details: [
                        {
                            description: 'Pendenz',
                            type: 'text',
                            disabled: false,
                            value: 'Noch zu bearbeiten',
                        },
                        {
                            description: 'Pendent seit',
                            type: 'text',
                            disabled: true,
                            value: '',
                        },
                        {
                            description: 'Barcode_ID',
                            type: 'text',
                            disabled: true,
                            value: '',
                        },
                        {
                            description: 'Erfasst am',
                            type: 'date',
                            disabled: false,
                            value: '',
                        },
                        {
                            description: 'Erledigt am',
                            type: 'date',
                            disabled: false,
                            value: '',
                        },
                    ],
                },
            }
        },
    })
</script>
